export const DEV_URL = '-dev';
export const currentUser = 'currentUser';
export const originPortal = 'originPortal';
export const CONTACT_MAIL = 'support@entreda.com';

export const CARD_BODY = {
  title: '',
  description: 'Fetching data...'
};

export enum PLATFORM_VALUES {
  WIN = 'Windows',
  Mac = 'Mac',
  iOS = 'iOS',
  Android = 'Android',
  Chrome_OS = 'Chrome OS',
  Others = 'Others'
}

export enum DeviceManagementType {
  EMPLOYEE = 'Employee Owned',
  CORP = 'Corp Managed'
}

export enum POSITION_IDS {
  SO = 4,
  SA = 3,
  DIVISION_MANAGER = 2,
  TEAM_MANAGER = 1,
  USER = 0
}

export enum Roles {
  GLOBAL_ADMIN = 'Global Admin',
  PRIMARY_SUPER_ADMIN = 'Primary Super Admin',
  SUPER_ADMIN = 'Super Admin',
  SUPER_USER = 'Super User',
  DIVISION_MANAGER = 'Division Manager',
  TEAM_MANAGER = 'Team Manager',
  USER = 'User'
}

//TODO: Move to ui models
export interface UserRoles {
  positionId: POSITION_IDS;
  role: Roles;
  canCreate: Roles[];
}

export const POSITION_IDS_LIST: { [key in Roles]: UserRoles } = {
  [Roles.GLOBAL_ADMIN]: {
    positionId: POSITION_IDS.SO,
    role: Roles.GLOBAL_ADMIN,
    canCreate: Object.values(Roles)
  },
  [Roles.PRIMARY_SUPER_ADMIN]: {
    positionId: POSITION_IDS.SA,
    role: Roles.PRIMARY_SUPER_ADMIN,
    canCreate: Object.values(Roles).filter(
      (role) => role != Roles.GLOBAL_ADMIN && role != Roles.PRIMARY_SUPER_ADMIN
    )
  },
  [Roles.SUPER_ADMIN]: {
    positionId: POSITION_IDS.SA,
    role: Roles.SUPER_ADMIN,
    canCreate: Object.values(Roles).filter(
      (role) => role != Roles.GLOBAL_ADMIN && role != Roles.PRIMARY_SUPER_ADMIN
    )
  },
  [Roles.SUPER_USER]: {
    positionId: POSITION_IDS.SA,
    role: Roles.SUPER_USER,
    canCreate: Object.values(Roles).filter(
      (role) =>
        role != Roles.GLOBAL_ADMIN &&
        role != Roles.PRIMARY_SUPER_ADMIN &&
        role != Roles.SUPER_ADMIN &&
        role != Roles.SUPER_USER
    )
  },
  [Roles.DIVISION_MANAGER]: {
    positionId: POSITION_IDS.DIVISION_MANAGER,
    role: Roles.DIVISION_MANAGER,
    canCreate: []
  },
  [Roles.TEAM_MANAGER]: {
    positionId: POSITION_IDS.TEAM_MANAGER,
    role: Roles.TEAM_MANAGER,
    canCreate: []
  },
  [Roles.USER]: {
    positionId: POSITION_IDS.USER,
    role: Roles.USER,
    canCreate: []
  }
};

//There are duplicate USER_STATUS in old code use this in new codebase
export enum USER_STATUS {
  NEW = 'New',
  PENDING = 'Pending',
  ACTIVE = 'Active',
  IN_ACTIVE = 'Inactive'
}

export const CYBERSCORE_FILTER_VALUES = [
  '0-100',
  '101-200',
  '201-300',
  '301-400',
  '401-500',
  '501-600',
  '601-700',
  '701-800'
];

export enum CYBER_HTTP_STATUS_CODE {
  COMPLETE = 1200,
  PARTIAL = 1206,
  NONE = 1402
}

export enum ComplianceStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  WARNING = 'WARNING'
}

// sat tranining status used in old. historic
export enum TrainingStatus {
  COMPLETED = 'Completed',
  INCOMPLETE = 'Incomplete'
}

export enum PhishingCampaignStatus {
  CLOSED = 'Closed',
  ACTIVE = 'Active',
  CREATED = 'Created',
  COMPLETED = 'Completed'
}

export enum PhishingCampaignBooleanValues {
  TRUE = 'true',
  FALSE = 'false'
}

export enum SatSummaryTrainingStatus {
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed'
}

export enum SatDetailsTrainingStatusValues {
  PASSED_DUE = 'Past Due',
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  PASSED = 'Passed'
}

export enum FilterTypes {
  CONTAINS = 'contains',
  EQUALS = 'equals'
}

export const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export enum ToolTips {
  EXPORT = 'Export',
  UPLOAD = 'Upload'
}

export const FACTOR_PARAM_NAME_FOR_COMPLIANCE_FROM_QUICKSIGHT = 'failingFactor';
export const METRIC_PARAM_NAME_FROM_QUICKSIGHT = 'metric';
export const DEVICE_OS_PARAM_NAME_FROM_QUICKSIGHT = 'deviceOs';
export const LOGIN_SOURCE_KEY = 'loginSource';
export enum LOGIN_SOURCE {
  NGP = 'NGP',
  DRUPAL = 'DRUPAL',
  COGNITO = 'COGNITO'
}

export enum HEADER {
  AUTHORIZATION = 'Authorization',
  CORRELATION_ID = 'X-CorrelationID',
  TENANT_ID = 'X-TenantID',
  USER_ID = 'X-userID',
  BUID_ID = 'X-buId'
}

// when -1 specified backend will treat it as all BUIds
export const ALL_BU_IDS = ['-1'];
